import { render, staticRenderFns } from "./pictureStyle.vue?vue&type=template&id=0655fda9&scoped=true"
import script from "./pictureStyle.vue?vue&type=script&lang=js"
export * from "./pictureStyle.vue?vue&type=script&lang=js"
import style0 from "./pictureStyle.vue?vue&type=style&index=0&id=0655fda9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0655fda9",
  null
  
)

export default component.exports